import { itemConstants } from "../constants/itemConstants"

const initialState = {
  item: {},
  items: [],
  fetchingItems: false,
  isCreatingNewItem: false,
  itemCreated: false,
  isFetchingItem: false,
  itemDeleted: false,
  isDeletingItem: false,
  updatingItemPreferences: false
}

export function itemReducers(state = initialState, action) {
  switch (action.type) {
    case itemConstants.CREATE_NEW_ITEM:
      return {
        ...state,
        isCreatingNewItem: true,
        itemCreated: false
      }
    case itemConstants.CREATE_NEW_ITEM_SUCCESS:
      return {
        ...state,
        isCreatingNewItem: false,
        itemCreated: true,
        item: action.item
      }
    case itemConstants.CREATE_NEW_ITEM_FAILED:
      return {
        ...state,
        isCreatingNewItem: false,
        itemCreated: false,
        createNewItemFailed: action.error
      }
    case itemConstants.DELETE_ITEM:
      return {
        ...state,
        isDeletingItem: true,
        itemDeleted: false
      }
    case itemConstants.DELETE_ITEM_SUCCESS:
      return {
        ...state,
        isDeletingItem: false,
        itemDeleted: true,
        item: action.item
      }
    case itemConstants.DELETE_ITEM_FAILED:
      return {
        ...state,
        isDeletingItem: false,
        deleteItemFailed: action.error
      }
    case itemConstants.FETCHING_ITEM:
      return {
        ...state,
        isFetchingItem: true
      }
    case itemConstants.SYNC_ITEMS_PASSAGE_PREFERENCES_REQUEST:
      return {
        ...state,
        updatingItemPreferences: true
      }
    case itemConstants.SYNC_ITEMS_PASSAGE_PREFERENCES_SUCCESS:
      return {
        ...state,
        item: { ...action.payload },
        updatingItemPreferences: false
      }
    case itemConstants.SYNC_ITEMS_PASSAGE_PREFERENCES_FAILED:
      return {
        ...state,
        updatingItemPreferences: false
      }
    case itemConstants.FETCH_ITEM_SUCCESS:
      return {
        ...state,
        item: action.item,
        isFetchingItem: false
      }
    case itemConstants.FETCH_ITEM_FAILED:
      return {
        ...state,
        fetchingItemFailed: action.error
      }

    case itemConstants.FETCH_ITEMS_REQUEST:
      return {
        ...state,
        fetchingItems: true
      }

    case itemConstants.FETCH_ITEMS_SUCCESS:
      return {
        ...state,
        fetchingItems: false,
        items: action.items
      }

    case itemConstants.FETCH_ITEMS_FAILURE:
      return {
        ...state,
        fetchingItems: false,
        cardError: action.error
      }

    case itemConstants.UPDATE_ITEMS_PASSAGE_REQUEST:
      return {
        ...state,
        updatingItemsPassage: true
      }

    case itemConstants.UPDATE_ITEMS_PASSAGE_SUCCESS:
      return {
        ...state,
        updatingItemsPassage: false
      }

    case itemConstants.UPDATE_ITEMS_PASSAGE_FAILURE:
      return {
        ...state,
        updatingItemsPassage: false,
        updateItemsPassageError: action.error
      }

    case itemConstants.dynamicConsts(action.key).request:
      return {
        ...state,
        [action.key]: true
      }
    case itemConstants.dynamicConsts(action.key).success:
      return {
        ...state,
        item: action.data,
        [action.key]: false
      }
    case itemConstants.dynamicConsts(action.key).failed:
      return {
        ...state,
        [action.key]: false,
        [`${action.key}Error`]: action.error
      }
    default:
      return state
  }
}
